module.exports = "/_next/static/images/WinitLawLogo-81522752ebce5c107aeb0c441419dda0.svg";